import React from "react";
import { Link } from "react-router-dom";
import { scrollToTop } from "./scrollHelpers";

function Footer() {
  const scrollAfterNavigation = () => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(scrollToTop);
    });
  };

  return (
    <footer className="siteFooter">
      <p>© {new Date().getFullYear()} OH MY CAR RENT A CAR LLC. Dubai, UAE.</p>
      <nav aria-label="Footer">
        <Link to="/about" onClick={scrollAfterNavigation}>About us</Link>
        <Link to="/contact" onClick={scrollAfterNavigation}>Contact</Link>
        <Link to="/terms" onClick={scrollAfterNavigation}>Terms & Conditions</Link>
      </nav>
    </footer>
  );
}

export default Footer;
